module.exports = __webpack_public_path__ + "img/Russell-Building-28143-030-474x262.71f5cd38.jpg";